import React from "react";
import styles from "./index.module.css";
import { useState } from "react";
import { useEffect } from "react";
import Calendar from "react-calendar";
import LineChart from "../LineChart";
import { Head, Row } from "../TableheadAndRow";
import DropDown from "../Dropdown";
import { rowCounts } from "../../../utils/constant";
import { useSelector } from "react-redux";
import {
  fetchPriceChangeAsyncThunk,
  setRangePriceChange,
} from "../../../store/slices/Products/dashboard.slice";
import { useDispatch } from "react-redux";
import { elements } from "chart.js";
import { PulseLoader } from "react-spinners";

const AnalyticsPrice = () => {
  const dispatch = useDispatch();
  const { rangePriceChange } = useSelector((store) => store.dashboard);
  const { date_range } = useSelector((store) => store.constant);
  const [pageNo, setPageNo] = useState(0);

  const [selRowCount, setSelRowCount] = useState(0);
  const [dateToggle, setDateToggle] = useState({
    start: false,
    end: false,
  });
  const [dateRange, setDateRange] = useState({
    start: "",
    end: "",
  });
  const [value, onChange] = useState({
    startValue: date_range.min_date ? new Date(date_range.min_date) : -1,
    endValue: date_range.max_date ? new Date(date_range.max_date) : -1,
  });

  const getRangePriceChange = async (
    start = value.startValue.toLocaleDateString("en-CA"),
    end = value.endValue.toLocaleDateString("en-CA")
  ) => {
    const response = await dispatch(
      fetchPriceChangeAsyncThunk({
        page: "analytics",
        parameters: { start, end },
      })
    );
    if (response?.payload.status === "success") {
      dispatch(setRangePriceChange(response.payload.data));
      getTableData(response.payload.data);
    }
  };

  useEffect(() => {
    if (Object.keys(date_range).length != 0) {
      getRangePriceChange();
    }
  }, [date_range]);

  const getTableData = (priceChangeData) => {
    let data = [];

    priceChangeData.map((element) => {
      let date = new Date(element.snapshot_date);
      let temp = {
        date:
          date.getDate() +
          "/" +
          (date.getMonth() + 1) +
          "/" +
          (date.getYear() - 100),
        totalChanges:
          Number(element.increased_count) + Number(element.decreased_count),
        increased: element.increased_count,
        decreased: element.decreased_count,
      };

      data.push(temp);
    });

    return data;
  };

  const handleDateRange = (e) => {
    let format = e.toLocaleDateString("en-US", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    });
    if (dateToggle.start) {
      onChange({ ...value, startValue: e });
      setDateRange({ ...dateRange, start: format });
      getRangePriceChange(
        e.toLocaleDateString("en-CA"),
        value.endValue.toLocaleDateString("en-CA")
      );
    }
    if (dateToggle.end) {
      onChange({ ...value, endValue: e });
      setDateRange({ ...dateRange, end: format });
      getRangePriceChange(
        value.startValue.toLocaleDateString("en-CA"),
        e.toLocaleDateString("en-CA")
      );
    }
  };

  const prepareChartData = (priceChangeData) => {
    let LineChartData = [
      {
        label: "increased",
        data: [],
        borderColor: "#ff9999", // Pink color for line
        backgroundColor: "#ff9999", // Transparent pink for points
        borderWidth: 2,
        tension: 0.4,
        pointBackgroundColor: "#ff9999",
        pointBorderColor: "#fff",
        pointRadius: 5,
      },
      {
        label: "decreased",
        data: [],
        borderColor: "#A4D8C9", // Pink color for line
        backgroundColor: "#A4D8C9", // Transparent pink for points
        borderWidth: 2,
        tension: 0.4,
        pointBackgroundColor: "#A4D8C9",
        pointBorderColor: "#fff",
        pointRadius: 5,
      },
    ];

    priceChangeData.map((element) => {
      LineChartData[0].data.push(element.increased_count);
      LineChartData[1].data.push(element.decreased_count);
    });

    return LineChartData;
  };

  const prepareLineChartLabel = (priceChangeData) => {
    let dates = [];
    priceChangeData.map((element) => {
      let date = new Date(element.snapshot_date);
      dates.push(
        date.getDate() +
          "/" +
          (date.getMonth() + 1) +
          "/" +
          (date.getYear() - 100)
      );
    });

    return dates;
  };

  useEffect(() => {
    if (Object.keys(date_range).length != 0) {
      setDateRange({
        start: new Date(date_range.min_date).toLocaleDateString("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        }),
        end: new Date(date_range.max_date).toLocaleDateString("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        }),
      });
      onChange({
        startValue: new Date(date_range.min_date),
        endValue: new Date(date_range.max_date),
      });
    }
  }, [date_range]);

  const onSelectedRowCount = (value, index) => {
    setPageNo(0);
    setSelRowCount(index);
  };
  const skipPages = (e) => {
    setPageNo((parseInt(pageNo / 5) + 1) * 5);
  };
  const skipPagesReverse = (e) => {
    setPageNo((parseInt(pageNo / 5) - 1) * 5);
  };
  const onPageNoChange = (e) => {
    setPageNo(e?.currentTarget?.dataset?.idx);
  };

  return (
    <div className={styles["container"]}>
      <div className={styles["graph"]}>
        <div className={styles["heading"]}>
          <div className={styles["titleAndPriceType"]}>
            <h3>Price Changes</h3>
            <div className={styles["priceType"]}>
              <span className={styles["increased"]}>
                <i class="bi bi-circle-fill"></i>
                <span>increased</span>
              </span>
              <span className={styles["decreased"]}>
                <i class="bi bi-circle-fill"></i>
                <span>decreased</span>
              </span>
            </div>
          </div>

          <div className={styles["dateRange"]}>
            <div className={styles["dates"]}>
              <div
                className={styles["start"]}
                onClick={() =>
                  setDateToggle({ start: !dateToggle.start, end: false })
                }
              >
                <input
                  type="text"
                  value={dateRange.start}
                  readOnly
                  onChange={setDateRange}
                />
                <i class="bi bi-calendar-date"></i>
              </div>
              <div
                className={styles["end"]}
                onClick={() =>
                  setDateToggle({ start: false, end: !dateToggle.end })
                }
              >
                <input
                  type="text"
                  value={dateRange.end}
                  readOnly
                  onChange={setDateRange}
                />
                <i class="bi bi-calendar-date"></i>
              </div>
            </div>
            {dateToggle.start && (
              <div className={styles["calendar"]}>
                <Calendar
                  value={value.startValue}
                  onChange={(e) => handleDateRange(e)}
                />
              </div>
            )}

            {dateToggle.end && (
              <div className={styles["calendar"]}>
                <Calendar
                  value={value.endValue}
                  onChange={(e) => handleDateRange(e)}
                />
              </div>
            )}
          </div>
        </div>

        <div className={styles["lineGraph"]}>
          <LineChart
            data={
              rangePriceChange != -1 ? prepareChartData(rangePriceChange) : []
            }
            labels={
              rangePriceChange != -1
                ? prepareLineChartLabel(rangePriceChange)
                : []
            }
          />
        </div>
      </div>

      <div className={styles["table"]}>
        <Head>
          <span>Date</span>
          <span>Total Changes</span>
          <span>Increased</span>
          <span>Decreased</span>
        </Head>
        {rangePriceChange == -1 ? (
          <div className="loader-container">
            {" "}
            <PulseLoader />{" "}
          </div>
        ) : (
          getTableData(rangePriceChange).map(
            (item, index) =>
              index >= pageNo * rowCounts[selRowCount] &&
              index < (Number(pageNo) + 1) * rowCounts[selRowCount] && (
                <Row
                  islast={rangePriceChange.length == index + 1 ? true : false}
                  key={index}
                >
                  <span>{item.date}</span>
                  <span>{item.totalChanges}</span>

                  <span>{item.increased}</span>
                  <span>{item.decreased}</span>
                </Row>
              )
          )
        )}
      </div>

      <div className={styles["rowCount"]}>
        <div className={styles["count"]}>
          <span>Row Count</span>
          <div className={styles["countDropdown"]}>
            <DropDown
              steps={rowCounts}
              selectedValue={selRowCount}
              onChange={onSelectedRowCount}
            />
          </div>
        </div>
        {rangePriceChange !== -1 && (
          <div className={styles["pages"]}>
            {pageNo < 5 ? <></> : <span onClick={skipPagesReverse}>&lt;</span>}
            {new Array(
              parseInt(
                getTableData(rangePriceChange).length / rowCounts[selRowCount]
              ) + 1 || 0
            )
              .fill(1)
              ?.map((el, idx) =>
                idx >= parseInt(pageNo / 5) * 5 &&
                idx < parseInt(pageNo / 5 + 1) * 5 ? (
                  <span
                    className={pageNo == idx ? styles["selected"] : ""}
                    onClick={onPageNoChange}
                    data-idx={idx}
                  >
                    {idx + 1}
                  </span>
                ) : (
                  <></>
                )
              )}
            {getTableData(rangePriceChange).length / rowCounts[selRowCount] <=
            (parseInt(pageNo / 5) + 1) * 5 ? (
              <></>
            ) : (
              <span onClick={skipPages}>&gt;</span>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default AnalyticsPrice;
